document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.Quiz-block');
  let currentSectionIndex = 0;

  function showSection(index) {
    sections.forEach((section, i) => {
      section.style.display = (i === index) ? 'block' : 'none';
    });
  }
  
  // Function to scroll to the top
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional: adds smooth scrolling effect
    });
  }

  document.querySelectorAll('.quiz-next').forEach(button => {
    button.addEventListener('click', (event) => {
      // Highlight the clicked button
      event.target.classList.add('highlighted');

      if (currentSectionIndex < sections.length - 1) {
        currentSectionIndex++;
        showSection(currentSectionIndex);
      }

      // Scroll to the top of the page
      scrollToTop();

      // Remove highlight after a short delay
      setTimeout(() => {
        event.target.classList.remove('highlighted');
      }, 500); // Adjust duration as needed
    });
  });

  document.querySelectorAll('.quiz-prev').forEach(button => {
    button.addEventListener('click', () => {
      if (currentSectionIndex > 0) {
        currentSectionIndex--;
        showSection(currentSectionIndex);
      }

      // Scroll to the top of the page
      scrollToTop();
    });
  });

  // Initial display
  showSection(currentSectionIndex);
});


document.addEventListener('DOMContentLoaded', function () {
  // Mapping of button IDs to desired text to store
  const buttonTextMapping = {
    'gtmquizq5cantsleep': 'fall asleep quickly.',
    'gtmquizq5wakeupatnight': 'stay asleep through the night.',
    'gtmquizq5waketoearly': 'wake up on time.'
  };

  const buttons = document.querySelectorAll('.quiz-getvalue');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      // Get the ID of the clicked button
      const buttonId = this.id;

      // Retrieve the text from the mapping
      const selectedText = buttonTextMapping[buttonId] || 'sleep';

      // Store the text in local storage
      localStorage.setItem('quizSelectedText', selectedText);

      console.log(`Saved: ${selectedText}`); // For debugging purposes
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Fetch the stored text from local storage
  const retrievedText = localStorage.getItem('quizSelectedText');
  
  if (retrievedText) {
    console.log(`Retrieved: ${retrievedText}`); // For debugging purposes
    
    // Use the retrieved text as needed
    // For example, display it on the page
    const resultDisplayElement = document.getElementById('result-display'); // Assume there's an element to display the text
    if (resultDisplayElement) {
      resultDisplayElement.textContent = retrievedText;
    }
    
    // Optionally, clear the stored value
    // localStorage.removeItem('quizSelectedText');
  } else {
    console.log('No selection found.');
  }
});

document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.quiz-points-slider'); // Select sections

    sliders.forEach(slider => {
        const infoBoxes = slider.querySelectorAll('.product--infobox');

        infoBoxes.forEach((box, index) => {
            const circle = document.createElement('div');
            circle.classList.add('circle-indicator');
            
            if (index === 0) circle.classList.add('active');
            
            box.insertBefore(circle, box.firstChild);
            
            // Create and append line connector for all but last item
            if (index < infoBoxes.length - 1) {
                const line = document.createElement('div');
                line.classList.add('line-connector');
                box.appendChild(line);
            }
        });

        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var circle = entry.target.querySelector('.circle-indicator');
                if (circle) {
                    if (entry.isIntersecting) {
                        circle.classList.add('active');
                    } else if (entry.boundingClientRect.top > 0) {
                        circle.classList.remove('active');
                    }
                }
            });
        }, { rootMargin: '0px 0px -50% 0px' });

        infoBoxes.forEach(function(box) {
            observer.observe(box);
        });
    });
});

  document.addEventListener('DOMContentLoaded', function() {
    // Get elements
    const ageInput = document.querySelector('input[name="age"]');
    const nextButton = document.querySelector('.GetAge');

    // Add click event listener
    nextButton.addEventListener('click', function(event) {
      const age = parseInt(ageInput.value);
      
      if (!isNaN(age)) { // Ensure that age is a number
        localStorage.setItem('userAge', age);
      }
    });

// Function to convert height from feet and inches to meters
function convertHeightToMeters(feet, inches) {
    const totalInches = (parseInt(feet) * 12) + parseInt(inches);
    const heightInMeters = totalInches * 0.0254;
    return heightInMeters;
}

// Function to convert weight from pounds to kilograms
function convertWeightToKg(pounds) {
    return pounds * 0.453592;
}

// Function to store heights and weights in local storage and calculate BMI
document.getElementById('weightlossWEIGHTDESIRED').addEventListener('change', function() {
    // Get height values
    const heightFeet = document.getElementById('heightInput-ft').value;
    const heightInches = document.getElementById('heightInput-in').value;

    // Get weight values
    const currentWeightPounds = document.getElementById('weightlossWEIGHT').value;
    const goalWeight = document.getElementById('weightlossWEIGHTDESIRED').value;

    if (currentWeightPounds && heightFeet && heightInches) {
        // Save current weight and goal weight in local storage
        localStorage.setItem('currentWeight', currentWeightPounds);
        localStorage.setItem('goalWeight', goalWeight);

        // Convert the height to meters and weight to kilograms
        const heightInMeters = convertHeightToMeters(heightFeet, heightInches);
        const currentWeightKg = convertWeightToKg(currentWeightPounds);
        
        // Calculate BMI
        const bmi = (currentWeightKg / (heightInMeters * heightInMeters)).toFixed(2);
        
        // Store BMI in local storage
        localStorage.setItem('bmi', bmi);
    }
});


    
  });

  document.addEventListener("DOMContentLoaded", function () {
    const target = document.querySelector('.date-append');
    if (!target) return;

    // today + 30 days
    const date = new Date();
    date.setDate(date.getDate() + 30);

    // Format: 16 Oct, 2025
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();

    const formatted = `${day} ${month}, ${year}`;

    target.textContent = formatted;
  });


  const STORAGE_KEY = 'stressSource';

// Apply label to all visible target elements
function applyStressSource(label) {
  if (!label) return;

  const targets = document.querySelectorAll('.stress-cause-show');
  targets.forEach(el => {
    el.textContent = label;
  });
}

// Listen for clicks on Stress Source buttons
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.stress-source');
  if (!btn) return;

  const label = btn.textContent.trim().replace(/\s+/g, ' ');
  if (!label) return;

  // Save for cross-page persistence
  try {
    localStorage.setItem(STORAGE_KEY, label);
  } catch (err) {
    console.warn('LocalStorage error:', err);
  }

  // Update immediately on the same page
  applyStressSource(label);
}, true);

// Apply saved value on every page load
document.addEventListener('DOMContentLoaded', function () {
  const saved = localStorage.getItem(STORAGE_KEY);
  applyStressSource(saved);
});

  
